// UI strings for the TypeScript modules, rendered by the server into
// <script id="js-i18n"> (layouts/_head, config/locales "js"). t('checkout.loading').
type Dict = { [key: string]: string | Dict }

let cache: Dict | null = null

function dict(): Dict {
  if (cache) return cache
  try {
    cache = JSON.parse(document.getElementById('js-i18n')?.textContent || '{}') as Dict
  } catch {
    cache = {}
  }
  return cache
}

export function t(key: string, vars: Record<string, string | number> = {}): string {
  const value = key.split('.').reduce<string | Dict | undefined>((node, part) => (typeof node === 'object' ? node[part] : undefined), dict())
  const text = typeof value === 'string' ? value : key
  return text.replace(/%\{(\w+)\}/g, (_, name: string) => String(vars[name] ?? ''))
}

// The page's language as a BCP 47 tag, for number formatting.
export function locale(): string {
  const segment = (dict().locale as string) || 'en'
  return segment === 'pt-br' ? 'pt-BR' : segment
}

export function resetI18n(): void {
  cache = null
}
